export default "__VITE_ASSET__CDgMu0wU__"